import { useEffect, useRef, useState } from 'react'
import { QueryDefaults, useCameraQuery } from 'trueye-component-library'
import apiConfig from '../../../apiConfig'
import CameraTreeItem from 'trueye-component-library/dist/models/camera/CameraTreeItem'
import mjpegWebSocket, {
  ConnectionDetails,
  ConnectionStatus,
} from '../websockets/mjpegWs'

export default function useVideoCard(
  authToken: string,
  cameraData: CameraTreeItem,
) {
  const imageRef = useRef<HTMLImageElement>(null)
  const [videoStatus, setVideoStatus] = useState<ConnectionStatus>('CONNECTING')
  const [videoWs, setVideoWs] = useState<mjpegWebSocket>()

  const { data, isFetching, isSuccess } = useCameraQuery(
    `${apiConfig.camera?.getCameraInfo}/${cameraData.id}`,
    true,
    QueryDefaults.STALE_TIME,
    cameraData.id,
  )

  useEffect(() => {
    return () => {
      if (videoWs?.close) {
        videoWs.close()
      }
    }
  }, [videoWs])

  useEffect(() => {
    if (isSuccess) {
      if (data) {
        const camera = data[0]
        if (camera.camera_condition === 'online') {
          const socketConfig: ConnectionDetails = {
            url: `${apiConfig.stream?.streamerService}`,
            macid: cameraData.macid || '',
            imageRef: imageRef,
            authToken: authToken.replace('Bearer ', ''),
            locationId: camera.location_id || '',
            onStatusChange: (message: ConnectionStatus) => {
              setVideoStatus(message)
            },
          }
          setVideoWs(new mjpegWebSocket(socketConfig))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess])

  return { data, imageRef, isFetching, videoStatus }
}
